import { useEffect, useState } from 'react'

import type * as Dailies from 'services/content/dailies/types'
import * as contentApi from 'services/content'
import SimpleDailyList from 'ui-component-library/components/DailyList/Simple'
import DailyItemContainer from '../DailyItem'

type Props = {
  contentType: string
  perPage: number
  orderBy: 'date'
  sort: 'desc'
  noResultsFoundText: string
  loadMoreText: string
}

function SimpleDailyListContainer(props: Props) {
  const { contentType, perPage, orderBy, sort, noResultsFoundText } = props
  const [isLoading, setIsLoading] = useState(true)
  const [daily, setDaily] = useState<Dailies.Result>()

  async function fetchDaily(params: Dailies.FetchDailyParams) {
    setIsLoading(true)

    const response = await contentApi.fetchDaily(params)

    setDaily(response)

    setIsLoading(false)
  }

  useEffect(() => {
    fetchDaily({
      contentType,
      perPage,
      orderBy,
      sort,
    })
  }, [])

  function handlePreviousClick() {
    if (daily?.previousUrl) {
      fetchDaily({ fullPath: daily.previousUrl })
    }
  }

  function handleNextClick() {
    if (daily?.nextUrl) {
      fetchDaily({ fullPath: daily.nextUrl })
    }
  }

  return (
    <SimpleDailyList
      noResultsFoundText={noResultsFoundText}
      isLoading={isLoading}
    >
      {daily && (
        <DailyItemContainer
          key={daily.slug}
          {...daily}
          onPreviousClick={daily.previousUrl ? handlePreviousClick : undefined}
          onNextClick={daily.nextUrl ? handleNextClick : undefined}
        />
      )}
    </SimpleDailyList>
  )
}

export default SimpleDailyListContainer
